<div width="100%" height="100%">
  <ng-container *ngTemplateOutlet="template" width="100%"></ng-container>
</div>

<ng-template #tiTemplate>
  <wiz-text-input #mainInput [wizValidator]="validateDefaultLanguage()"
                  [manageModel]=false width="100%"
                  [wizLabel]="wizLabel"
                  [wizRightIcon]="'flag'"
                  [wizMandatory]="wizMandatory"
                  [wizPlaceholder]="wizPlaceholder"
                  [wizShowErrors]="wizShowErrors"
                  [wizMaxChars]="wizMaxChars"
                  [wizShowLabel]="wizShowLabel"
                  [wizDisabled]="wizDisabled">
  </wiz-text-input>
</ng-template>

<ng-template #taTemplate>
  <wiz-text-area #mainInput [wizValidator]="validateDefaultLanguage()"
                [manageModel]=false width="100%" height="100%"
                [wizLabel]="wizLabel"
                [wizRightIcon]="'flag'"
                [wizMandatory]="wizMandatory"
                [wizPlaceholder]="wizPlaceholder"
                [wizShowErrors]="wizShowErrors"
                [wizMaxChars]="wizMaxChars"
                [wizShowLabel]="wizShowLabel"
                [wizDisabled]="wizDisabled">
  </wiz-text-area>
</ng-template>
